import 'angular';

import { BranchCustomersCtrl }                from './customers.branch';
import { CashPaymentCtrl }                    from './customer.cash-payment';
import { ChangeCustomerCtrl }                 from './customer.change';
import { CustomerBilledCtrl }                 from './customer.billed';
import { CustomerBilledDirective }            from './customer.billed.directive';
import { CustomerCtrl }                       from './customer';
import { CustomerEventsCtrl }                 from './customer.events';
import { CustomerEventsDirective }            from './customer.events.directive';
import { CustomerInspectionsCtrl }            from './customer.inspections';
import { CustomerInspectionsDirective }       from './customer.inspections.directive';
import { CustomerInvoicesCtrl }               from './customer.invoices';
import { CustomerInvoicesDirective }          from './customer.invoices.directive';
import { CustomerQuotesCtrl }                 from './customer.quotes';
import { CustomerQuotesDirective }            from './customer.quotes.directive';
import { CustomersCtrl }                      from './customers';
import { CustomerSelectionCtrl }              from './customer.selection';
import { CustomerSelectionDirective }         from './customer.selection.directive';
import { CustomerSelectionForAccountingCtrl } from './customer.selection-for-accounting';
import { CustomerService }                    from './customer.service';
import { CustomersStates }                    from './customers.states.ajs';
import { CustomerStatementSettingsCtrl }      from './customer.statement-settings';
import { CustomerVehiclesCtrl }               from './customer.vehicles';
import { CustomerVehiclesDirective }          from './customer.vehicles.directive';
import { EmailCustomerStatementCtrl }         from './customer.email-statement';
import { ResolveCustomerMatchesCtrl }         from './customer.resolve-matches';

import './customer-payments/customer-payments.module.ajs';

angular.module('workshop.customers', [
  'workshop.customerPayments'
]).config(CustomersStates)
  .controller('BranchCustomersCtrl', BranchCustomersCtrl)
  .controller('CashPaymentCtrl', CashPaymentCtrl)
  .controller('ChangeCustomerCtrl', ChangeCustomerCtrl)
  .controller('CustomerBilledCtrl', CustomerBilledCtrl)
  .controller('CustomerCtrl', CustomerCtrl)
  .controller('CustomerEventsCtrl', CustomerEventsCtrl)
  .controller('CustomerInspectionsCtrl', CustomerInspectionsCtrl)
  .controller('CustomerInvoicesCtrl', CustomerInvoicesCtrl)
  .controller('CustomerQuotesCtrl', CustomerQuotesCtrl)
  .controller('CustomersCtrl', CustomersCtrl)
  .controller('CustomerSelectionCtrl', CustomerSelectionCtrl)
  .controller('CustomerSelectionForAccountingCtrl', CustomerSelectionForAccountingCtrl)
  .controller('CustomerStatementSettingsCtrl', CustomerStatementSettingsCtrl)
  .controller('CustomerVehiclesCtrl', CustomerVehiclesCtrl)
  .controller('EmailCustomerStatementCtrl', EmailCustomerStatementCtrl)
  .controller('ResolveCustomerMatchesCtrl', ResolveCustomerMatchesCtrl)
  .directive('customerBilled', CustomerBilledDirective)
  .directive('customerEvents', CustomerEventsDirective)
  .directive('customerInspections', CustomerInspectionsDirective)
  .directive('customerInvoices', CustomerInvoicesDirective)
  .directive('customerQuotes', CustomerQuotesDirective)
  .directive('customerSelection', CustomerSelectionDirective)
  .directive('customerVehicles', CustomerVehiclesDirective)
  .factory('Customer', CustomerService);